import { render, staticRenderFns } from "./PaymentStart.vue?vue&type=template&id=3b59cc54&"
import script from "./PaymentStart.vue?vue&type=script&lang=js&"
export * from "./PaymentStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports